// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/layers/search_platform_layer
export const STATSIG_SEARCH_BACKEND_LAYER = 'search_platform_layer';

// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/layers/full_page_search_layer
export const STATSIG_FULL_PAGE_SEARCH_LAYER = 'full_page_search_layer';

// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/layers/quick_find_layer
export const STATSIG_QUICK_FIND_LAYER = 'quick_find_layer';

export const DEFAULT_STATSIG_EXPERIMENT_CONFIG = {
	experimentId: 'default',
	shadowExperimentId: 'default',
	controlId: 'default',
	abTestId: 'default',
} as const;
